import { END_POINTS } from "../constants/urls";
import { CommonBody, CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

// interface CommonResponseType {
//   status: number;
//   message: string;
//   statusCode: number;
// }

// interface PostLoginBody {
//   email: string;
//   password: string;
// }

export const categoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        limit?: number;
        page?: number;
        parentId?: string;
        status?: boolean;
        isBlocked?: boolean;
      }
    >({
      query: ({ page, limit, search, isBlocked, status, parentId }) => ({
        url: `${END_POINTS.getCategory}?page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }${isBlocked ? `&isBlocked=${isBlocked}` : ""}${
          status ? `&status=${status}` : ""
        }${parentId ? `&parentId=${parentId}` : ""}`,
        method: "GET",
      }),
    }),
    getCatDropDownList: builder.query<
      CommonResponseType & { data: any },
      { parentId?: string }
    >({
      query: ({parentId}) => {
        return {
          url: `${END_POINTS.getCategoryDropDownList}${parentId?`?parentId=${parentId}`:''}`,
          method: "GET",
        };
      },
    }),
    getCategoryById: builder.query<CommonResponseType & { data: any }, {}>({
      query: (id) => ({
        url: `${END_POINTS.getCategoryById}/${id}`,
        method: "GET",
      }),
    }),
    addCategory: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addCategory,
        method: "POST",
        body,
      }),
    }),
    updateCategory: builder.mutation<
      CommonResponseType,
      { body: any; id: any }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCategory}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteCategory: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCategory}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetCategoryQuery,
  useGetCategoryQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetCategoryByIdQuery,
  useLazyGetCategoryByIdQuery,
  useGetCatDropDownListQuery,
} = categoryApi;
